module.exports = __webpack_public_path__ + "static/img/icon3.8cf6e43.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon3.png
// module id = 6ZZs
// module chunks = 1